import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// returns the component in for the config whose inputs most closely match the props
export function withMultipleConfigs(configs) {
    return (props) => {
        const [matchingConfig] = configs
            .map((config) => {
            var _a, _b, _c;
            const propOccurrences = (_a = config.inputs) === null || _a === void 0 ? void 0 : _a.filter((input) => Object.prototype.hasOwnProperty.call(props, input.name)).length;
            // The percentage of the inputs has a matching prop
            const percentageMatch = (propOccurrences !== null && propOccurrences !== void 0 ? propOccurrences : 0) / ((_c = (_b = config.inputs) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 1);
            return Object.assign(Object.assign({}, config), { percentageMatch });
        })
            .sort((a, b) => { var _a, _b; return ((_a = b.percentageMatch) !== null && _a !== void 0 ? _a : 0) - ((_b = a.percentageMatch) !== null && _b !== void 0 ? _b : 0); });
        if (!matchingConfig)
            return null;
        const Component = matchingConfig.component;
        return _jsx(Component, Object.assign({}, props));
    };
}
//# sourceMappingURL=withMultipleConfigs.js.map